import { useFetch } from '../../hooks/useFetch';
import { settingsApi } from '../../api/contentApi';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Logo du site — gère deux variantes selon le fond sur lequel il est posé :
 * `tone="clair"` (fond blanc/clair, logo sombre) ou `tone="sombre"` (fond marine/sombre, logo blanc).
 * Chacune est éditable depuis Paramètres → Général ; sans image, replie sur le texte
 * "AXEO Services" (hérite du style du parent : couleur, poids, taille).
 */
export function SiteLogo({ tone = 'clair', height = 40 }) {
  const { data: settings } = useFetch(() => settingsApi.public(), []);
  const cle = tone === 'sombre' ? 'site.logo_sombre_url' : 'site.logo_clair_url';
  const logoUrl = settings?.[cle];

  if (logoUrl) {
    return <img src={`${API_URL}${logoUrl}`} alt="AXEO Services" style={{ height, width: 'auto', display: 'block' }} />;
  }

  return 'AXEO Services';
}
